module.exports = __webpack_public_path__ + "static/media/xiangshanicon.1c2844b0.webp";